var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    attrs: {
      "tile": "",
      "elevation": "0"
    }
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm2": ""
    }
  }, [_vm._v("옵션명 개수")]), _c('v-flex', {
    attrs: {
      "grow-shrink-0": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.additionCountItems,
      "item-text": "text",
      "item-value": "value",
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.additionCount,
      callback: function ($$v) {
        _vm.additionCount = $$v;
      },
      expression: "additionCount"
    }
  })], 1)], 1)], 1), _c('v-divider'), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm2": ""
    }
  }, [_vm._v("옵션입력")]), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    staticClass: "px-1",
    attrs: {
      "xs10": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    staticClass: "text-center",
    attrs: {
      "xs4": ""
    }
  }, [_vm._v("추가상품명")]), _c('v-flex', {
    staticClass: "text-center",
    attrs: {
      "xs4": ""
    }
  }, [_vm._v("추가상품값")]), _c('v-flex', {
    staticClass: "text-center",
    attrs: {
      "xs4": ""
    }
  }, [_vm._v("추가상품가")])], 1)], 1), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  })], 1), _c('v-divider', {
    staticClass: "mt-2"
  }), _vm._l(_vm.additionCount, function (i, index) {
    return _c('v-layout', {
      key: index,
      staticClass: "mt-2 mx-n1"
    }, [_c('v-flex', {
      staticClass: "px-1",
      attrs: {
        "xs10": ""
      }
    }, [_c('v-layout', {
      staticClass: "mx-n1"
    }, [_c('v-flex', {
      staticClass: "px-1",
      attrs: {
        "xs4": ""
      }
    }, [_c('v-text-field', {
      attrs: {
        "dense": "",
        "outlined": "",
        "hide-details": ""
      },
      model: {
        value: _vm.additionGroups[index].name,
        callback: function ($$v) {
          _vm.$set(_vm.additionGroups[index], "name", $$v);
        },
        expression: "additionGroups[index].name"
      }
    })], 1), _c('v-flex', {
      staticClass: "px-1",
      attrs: {
        "xs4": ""
      }
    }, [_c('v-text-field', {
      attrs: {
        "dense": "",
        "outlined": "",
        "hide-details": ""
      },
      model: {
        value: _vm.additionGroups[index].value,
        callback: function ($$v) {
          _vm.$set(_vm.additionGroups[index], "value", $$v);
        },
        expression: "additionGroups[index].value"
      }
    })], 1), _c('v-flex', {
      staticClass: "px-1",
      attrs: {
        "xs4": ""
      }
    }, [_c('v-text-field', {
      attrs: {
        "dense": "",
        "outlined": "",
        "hide-details": ""
      },
      on: {
        "input": function ($event) {
          _vm.additionGroups[index].salePrice = _vm.additionGroups[index].salePrice.replace(/[^0-9,]/, '');
        }
      },
      model: {
        value: _vm.additionGroups[index].salePrice,
        callback: function ($$v) {
          _vm.$set(_vm.additionGroups[index], "salePrice", $$v);
        },
        expression: "additionGroups[index].salePrice"
      }
    })], 1)], 1)], 1), _c('v-flex', {
      staticClass: "px-1",
      attrs: {
        "xs2": ""
      }
    }, [1 < _vm.additionCount ? _c('v-btn', {
      staticClass: "px-1 mr-1 primary--text",
      staticStyle: {
        "min-width": "auto"
      },
      attrs: {
        "color": "white",
        "width": "36"
      },
      on: {
        "click": function ($event) {
          _vm.additionCount--;
        }
      }
    }, [_c('v-icon', [_vm._v("mdi-minus")])], 1) : _vm._e()], 1)], 1);
  }), _c('v-layout', {
    staticClass: "mt-2 mx-n1"
  }, [_c('v-flex', {
    staticClass: "px-1"
  }, [_c('v-btn', {
    attrs: {
      "width": "100%",
      "color": "primary",
      "dark": ""
    },
    on: {
      "click": function ($event) {
        return _vm.generate();
      }
    }
  }, [_vm._v("옵션목록으로 적용"), _c('v-icon', {
    staticClass: "ml-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-chevron-down")])], 1)], 1), _c('v-flex', {
    staticClass: "px-1",
    attrs: {
      "xs2": ""
    }
  }, [_vm.additionCount < _vm.additionCountItems.length ? _c('v-btn', {
    staticClass: "px-1",
    staticStyle: {
      "min-width": "auto"
    },
    attrs: {
      "width": "36",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        _vm.additionCount++;
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-plus")])], 1) : _vm._e()], 1)], 1)], 2)], 1)], 1), _c('v-divider', {
    staticClass: "mt-4"
  }), _c('v-card-text', [_c('v-layout', {
    staticClass: "mt-4"
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_vm._v("옵션목록")]), _c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-layout', [_c('v-spacer'), _c('v-flex', {
    staticClass: "px-1"
  }, [_c('v-select', {
    attrs: {
      "items": _vm.operatorItems,
      "label": "연산자",
      "persistent-placeholder": "",
      "outlined": "",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: _vm.header.operator,
      callback: function ($$v) {
        _vm.$set(_vm.header, "operator", $$v);
      },
      expression: "header.operator"
    }
  })], 1), _c('v-flex', {
    staticClass: "px-1"
  }, [_c('v-text-field', {
    attrs: {
      "label": "추가상품가",
      "persistent-placeholder": "",
      "outlined": "",
      "dense": "",
      "hide-details": ""
    },
    on: {
      "input": function ($event) {
        _vm.header.salePrice = _vm.header.salePrice.replace(/[^0-9]/, '');
      }
    },
    model: {
      value: _vm.header.salePrice,
      callback: function ($$v) {
        _vm.$set(_vm.header, "salePrice", $$v);
      },
      expression: "header.salePrice"
    }
  })], 1), _c('v-flex', {
    staticClass: "px-1"
  }, [_c('v-text-field', {
    attrs: {
      "label": "재고수량",
      "persistent-placeholder": "",
      "outlined": "",
      "dense": "",
      "hide-details": ""
    },
    on: {
      "input": function ($event) {
        _vm.header.stock = _vm.header.stock.replace(/[^0-9]/, '');
      }
    },
    model: {
      value: _vm.header.stock,
      callback: function ($$v) {
        _vm.$set(_vm.header, "stock", $$v);
      },
      expression: "header.stock"
    }
  })], 1), _c('v-flex', {
    staticClass: "px-1",
    attrs: {
      "xs2": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "secondary",
      "small": "",
      "height": "40"
    },
    on: {
      "click": _vm.batch
    }
  }, [_vm._v("선택목록 일괄수정")])], 1)], 1), _c('v-divider', {
    staticClass: "mt-2"
  }), _c('v-data-table', {
    attrs: {
      "headers": _vm.additionalProductsHeaders,
      "items": _vm.additionalProducts.filter(function (addition) {
        return !addition.isDeleted;
      }),
      "item-key": "additionalValue",
      "show-select": ""
    },
    scopedSlots: _vm._u([{
      key: "item.salePrice",
      fn: function (_ref) {
        var item = _ref.item;
        return _c('v-text-field', {
          staticClass: "price",
          attrs: {
            "dense": "",
            "hide-details": ""
          },
          model: {
            value: item.salePrice,
            callback: function ($$v) {
              _vm.$set(item, "salePrice", $$v);
            },
            expression: "item.salePrice"
          }
        });
      }
    }, {
      key: "item.stock",
      fn: function (_ref2) {
        var item = _ref2.item;
        return _c('v-text-field', {
          staticClass: "price",
          attrs: {
            "dense": "",
            "hide-details": ""
          },
          model: {
            value: item.stock,
            callback: function ($$v) {
              _vm.$set(item, "stock", $$v);
            },
            expression: "item.stock"
          }
        });
      }
    }, {
      key: "item.actions",
      fn: function (_ref3) {
        var item = _ref3.item;
        return _c('v-icon', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.remove(item);
            }
          }
        }, [_vm._v("mdi-delete")]);
      }
    }]),
    model: {
      value: _vm.selected,
      callback: function ($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  })], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }